<template>
    <div>
        <b-form-group label="Başlık" label-for="title">
            <b-form-input
                id="title"
                v-model="localValue.Title"
                placeholder="Menü Başlığı"
            />
        </b-form-group>

        <b-form-group label="Açıklama" label-for="description">
            <b-form-textarea
                id="description"
                v-model="localValue.Description"
                placeholder="Menü açıklaması"
                rows="2"
            />
        </b-form-group>

        <b-row >
            
            <b-col md="6">
                <b-form-group label="Link" label-for="ctaHref">
                    <b-form-input
                        id="ctaHref"
                        v-model="localValue.CtaHref"
                        placeholder="/detay-sayfasi"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group label="Alt Metni" label-for="ctaText">
                        <b-form-input
                            id="ctaText"
                            v-model="localValue.CtaText"
                            placeholder="Daha Fazla"
                        />
                    </b-form-group>
                </b-col>
        </b-row>
    </div>
</template>

<script>
import { BRow, BCol, BFormGroup, BFormInput, BFormTextarea } from 'bootstrap-vue';

export default {
    name: 'NavigationTranslationForm',
    components: {
        BRow,
        BCol,
        BFormGroup,
        BFormInput,
        BFormTextarea
    },
    props: {
        value: {
            type: Object,
            required: true
        },
        languageCode: {
            type: String,
            required: true
        },
        showCta: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        localValue: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        }
    }
};
</script>